import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useCallback, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { Autocomplete } from "../../components/Autocomplete";
import { Table } from "../../components/Table";
import { listBlacklistEmail, listBlacklistSms } from "../../services/blacklist";
import { useStyles } from "./styles";

export function Blacklist() {
  const styles = useStyles();
  const [campaignTypeSelected, setCampaignTypeSelected] = useState<string>();
  const [recipient, setRecipient] = useState<string>();

  const blacklist = useQuery(
    ["blacklist", campaignTypeSelected, recipient],
    async () => {
      switch (campaignTypeSelected) {
        case "S":
          return await listBlacklistSms(recipient);
        case "E":
          return await listBlacklistEmail(recipient);
      }
    },
    { enabled: Boolean(campaignTypeSelected) }
  );

  const campaignsType = useMemo(() => {
    return [
      { value: "S", label: "SMS" },
      { value: "E", label: "Email" },
    ];
  }, []);

  const handleChange = useCallback((_: any, campaign: any) => {
    setCampaignTypeSelected(campaign.value);
  }, []);

  return (
    <>
      <div className={styles.root}>
        <Typography variant="h4">Blacklist</Typography>
        <Typography variant="body2">
          Selecione um tipo de campanha para listar as pessoas.
        </Typography>
      </div>
      <div className={styles.rootActions}>
        <Autocomplete
          fullWidth
          label="Tipo de campanhas"
          options={campaignsType}
          getOptionLabel={(option) => option.label}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          className={styles.inputPhone}
          variant="outlined"
          label="Destinatário"
          onChange={({ target: { value } }) => setRecipient(value)}
        />
      </div>
      <Paper variant="outlined" elevation={0} className={styles.paper}>
        <Table
          toolbar={false}
          data={blacklist.data as []}
          isLoading={blacklist.isFetching}
          columns={[
            { title: "Nome", field: "nome" },
            { title: "Documento", field: "documento" },
            { title: "Celular 1", field: "celular1" },
            { title: "Celular 2", field: "celular2" },
            { title: "Celular 3", field: "celular3" },
            { title: "Celular 4", field: "celular4" },
          ]}
          options={{
            actionsColumnIndex: -1,
            pageSize: 5,
            selectionProps: () => ({
              color: "primary",
            }),
          }}
          style={{ backgroundColor: "transparent" }}
          headerStyle={{ backgroundColor: "transparent" }}
        />
      </Paper>
    </>
  );
}
